import React from 'react'
import "./color.css"

function WhiteW() {
    var x = localStorage.getItem("percentage weight")
    return (
        <div className = "init__background">
            {x == "NaN" ? "null": x} 
        </div>
    )
}

export default WhiteW
